import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/Button/Button'

interface ScheduledQueryBackHeaderProps {
  to: string
}

export const ScheduledQueryBackHeader: React.FC<ScheduledQueryBackHeaderProps> = ({ to }) => {
  const navigate = useNavigate()

  return (
    <div className='zocks-pl-2.0'>
      <Button variant='link' className='back-button' aria-label='Back' onClick={() => navigate(to)}>
        <i className='bi bi-chevron-left' aria-hidden='true' />
      </Button>
    </div>
  )
}
